import { baseApi } from "common/redux/core/api.base";
import { ConfigurationHubService } from "../../services/configuration-hub.service";
import {
  CreateAssignmentRequest,
  UpdateAssignmentRequest
} from "../../models/configuration-hub.model";

const assignmentCommands = baseApi.injectEndpoints({
  endpoints: (build) => ({
    createAssignment: build.mutation<any, CreateAssignmentRequest>({
      queryFn: (assignment: CreateAssignmentRequest) => {
        return ConfigurationHubService.createAssignment(assignment);
      },
      invalidatesTags: ["ASSIGNMENTS"]
    }),

    updateAssignment: build.mutation<any, UpdateAssignmentRequest>({
      queryFn: (updateRequest: UpdateAssignmentRequest) => {
        return ConfigurationHubService.updateAssignment(updateRequest);
      },
      invalidatesTags: ["ASSIGNMENTS"]
    }),

    deleteAssignment: build.mutation<void, number>({
      queryFn: async (assignmentId: number) => {
        const response = await ConfigurationHubService.deleteAssignment(
          assignmentId
        );
        return { data: undefined };
      },
      invalidatesTags: ["ASSIGNMENTS"]
    })
  })
});

export const {
  useCreateAssignmentMutation,
  useUpdateAssignmentMutation,
  useDeleteAssignmentMutation
} = assignmentCommands;
